export default __webpack_public_path__ + "7efaa4daa107e102245c83af4c67ea1c.ttf";